/* global MitekSettings */

//#region NAVIGATION HAMBURGER ANIMATOR
function createCanvasAnimator(canvas, navContainer) {
  // CANVAS CONFIGURATION
  const ctx = canvas.getContext('2d');

  // Set fixed size for the hamburger canvas element
  const dpr = window.devicePixelRatio || 1;
  const SIZE = 45;
  canvas.width = SIZE * dpr;
  canvas.height = SIZE * dpr;
  canvas.style.width = `${SIZE}px`;
  canvas.style.height = `${SIZE}px`;
  ctx.scale(dpr, dpr);

  // Canvas Drawing Parameters
  const centerX = SIZE / 2;
  const centerY = SIZE / 2;
  const lineWidth = 4;
  const radius = SIZE / 2 - lineWidth / 2; // Adjusts radius to fit area
  const fullCircle = 2 * Math.PI;
  const animationSpeed = 0.12; // Quick speed for a UI interaction
  const startAngle = -0.5 * Math.PI; // Starts at 12 o'clock

  // STATE
  let currentEndAngle = 0; // Tracks the size of the arc (0 to fullCircle)
  let animationFrameId = null;

  // CANVAS DRAWING FUNCTIONS

  function drawArc() {
    ctx.clearRect(0, 0, SIZE, SIZE);

    // Draw the transparent track (Background)
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, fullCircle);
    ctx.strokeStyle = 'transparent';
    ctx.lineWidth = lineWidth;
    ctx.stroke();

    // Draw the animated arc segment
    if (currentEndAngle > 0) {
      ctx.beginPath();
      ctx.arc(
        centerX,
        centerY,
        radius,
        startAngle,
        currentEndAngle + startAngle
      );
      ctx.strokeStyle = '#0F0F0F'; // Indigo color
      ctx.lineWidth = lineWidth;

      // Only set lineCap='round' if the arc isn't a full circle
      ctx.lineCap = currentEndAngle < fullCircle ? 'round' : 'butt';

      ctx.stroke();
    }
  }

  // Animation loop. Runs until arc is drawn or erased completely
  // @param {boolean} isMenuOpening To determine which direction the animation should go, true for opening, false for closing
  function animateCircle(isMenuOpening) {
    const step = isMenuOpening ? animationSpeed : -animationSpeed;
    currentEndAngle += step;
    // console.log(isMenuOpening, 'isMenuOpening');
    // console.log(currentEndAngle, 'currentEndAngle');
    // console.log(fullCircle, 'fullCircle');
    // console.log(step, 'step');
    // console.log(animationFrameId, 'animationFrameId');

    // Boundary Checks and Stopping

    // Drawing complete (Menu is now OPEN)
    if (currentEndAngle >= fullCircle) {
      currentEndAngle = fullCircle;
      stopAnimation();
      navContainer.classList.add('toggled');
      drawArc(); // Ensure final state is drawn with lineCap='butt'
      return;
    }

    // Erasing complete (Menu is now CLOSED)
    if (currentEndAngle <= 0) {
      currentEndAngle = 0;
      stopAnimation();
      setTimeout(() => {
        const wasMenuReopened = navContainer.classList.contains('toggled');
        if (!wasMenuReopened) {
          navContainer.classList.add('closed');
        }
      }, 350);
      navContainer.classList.remove('closing', 'toggled');
      drawArc(); // Ensure final state is truly clear (0 length)
      return;
    }

    // Continue Loop
    drawArc();
    animationFrameId = requestAnimationFrame(() =>
      animateCircle(isMenuOpening)
    );
  }

  function stopAnimation() {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
  }

  // Called on page load to draw the initial state of the canvas
  drawArc();

  // Return the necessary control functions
  return {
    start: animateCircle,
    stop: stopAnimation,
    drawInitial: drawArc,
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const navContainer = document.getElementById('site-navigation');
  const canvas = document.getElementById('hamburger__canvas');

  // Fail gracefully if essential elements are missing
  if (!menuToggle || !navContainer || !canvas) {
    console.warn(
      'Missing required menu elements (button, nav, or canvas). Animation skipped.'
    );
    // Fallback: If canvas is missing, just use basic CSS class toggling
    if (menuToggle && navContainer) {
      menuToggle.addEventListener('click', () => {
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', !isExpanded);
        navContainer.classList.toggle('toggled', !isExpanded);
        menuToggle.classList.toggle('is-active', !isExpanded);
      });
    }
    return;
  }

  // MAIN EXECUTION SCOPE
  let isMenuOpen = false; // Tracks the menu state

  // Instantiate the canvas animator controller and getting in return the control functions
  const animator = createCanvasAnimator(canvas, navContainer);

  // Main toggle function
  function toggleMenu() {
    // 1. Stop any currently running animation
    animator.stop();

    // 2. Flip the state
    isMenuOpen = !isMenuOpen;

    // 3. Update DOM
    menuToggle.setAttribute('aria-expanded', isMenuOpen);
    menuToggle.classList.toggle('is-active', isMenuOpen);

    // 4. Set the initial visibility
    navContainer.classList.add('toggled');
    if (isMenuOpen) {
      navContainer.classList.remove('closed');
    } else {
      // navContainer.classList.remove('toggled');
      navContainer.classList.add('closing');
    }

    // 5. Start the Canvas Animation
    animator.start(isMenuOpen);
  }

  // EVENT LISTENER
  menuToggle.addEventListener('click', toggleMenu);
});

//#region MODAL VIDEO
document.addEventListener('DOMContentLoaded', function () {
  // 1. Select Elements
  const playTrigger = document.querySelector('.layout-home__play-trigger');
  const modal = document.querySelector('.layout-home__modal');
  const closeBtn = document.querySelector('.layout-home__close-btn');
  const iframe = modal ? modal.querySelector('iframe') : null;

  // Store the element that opened the modal to return focus later
  let previousActiveElement;

  if (!playTrigger || !modal || !iframe) return;

  // 2. Setup Video logic & Create Focus Sentinel
  let videoSrc = iframe.getAttribute('src');
  iframe.setAttribute('src', '');
  const symbol = videoSrc.indexOf('?') > -1 ? '&' : '?';
  videoSrc += symbol + 'autoplay=1';

  // Create an invisible dummy element at the end of the modal
  // This catches the focus when it exits the iframe
  const bottomSentinel = document.createElement('div');
  bottomSentinel.setAttribute('tabindex', '0');
  bottomSentinel.style.cssText =
    'position: absolute; height: 1px; width: 1px; opacity: 0; pointer-events: none;';
  modal.appendChild(bottomSentinel);

  const getFocusableElements = () => {
    return modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe'
    );
  };

  // 3. Open Function
  const openModal = () => {
    previousActiveElement = document.activeElement;

    modal.classList.add('is-active');
    iframe.setAttribute('src', videoSrc);

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (window.innerWidth < 768) {
      // Requesting native fullscreen which forces landscape on most phones
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.webkitRequestFullscreen) {
        /* Safari */
        iframe.webkitRequestFullscreen();
      } else if (iframe.msRequestFullscreen) {
        /* IE11 */
        iframe.msRequestFullscreen();
      }
    }

    // Delay focus slightly to ensure visibility rendering
    setTimeout(() => {
      closeBtn.focus();
    }, 50);
  };

  // 4. Close Function
  const closeModal = () => {
    modal.classList.remove('is-active');
    iframe.setAttribute('src', '');

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    if (previousActiveElement) {
      previousActiveElement.focus();
    }
  };

  // 5. Sentinel Listener (The Scroll Fix)
  // When focus hits the bottom dummy element, loop back to the top immediately.
  // Since the dummy is inside the modal, the browser won't scroll the page.
  bottomSentinel.addEventListener('focus', () => {
    closeBtn.focus();
  });

  // 6. Standard Event Listeners
  playTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    openModal();
  });

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal();
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // 7. Focus fence for safety net
  document.addEventListener('focusin', (e) => {
    if (modal.classList.contains('is-active')) {
      if (!modal.contains(e.target)) {
        e.preventDefault();
        closeBtn.focus();
      }
    }
  });

  // 8. Keydown Handler
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-active')) return;

    if (e.key === 'Escape') {
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      const focusableContent = getFocusableElements();
      const firstFocusableElement = focusableContent[0];

      if (e.shiftKey) {
        // Shift + Tab (Backwards)
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          // If the last element is the sentinel, focus the iframe (element before sentinel)
          // or just focus the iframe directly
          iframe.focus();
        }
      }
    }
  });
});

// #region CONTACT HELPERS
function toLowerKebab(str) {
  return str.toLowerCase().replace(/\s+/g, '-');
}

// ACCESSIBILITY HANDLER
function handleDropdownAccessibility(
  customSelect,
  trigger,
  optionsContainer,
  hiddenInput
) {
  // Check for Empty State
  if (customSelect.classList.contains('is-empty')) {
    customSelect.removeAttribute('tabindex');
    customSelect.setAttribute('aria-disabled', 'true');
    trigger.setAttribute('aria-disabled', 'true');
    return;
  }

  // Setup Attributes
  customSelect.setAttribute('tabindex', '0');
  customSelect.setAttribute('role', 'combobox');
  customSelect.setAttribute('aria-haspopup', 'listbox');
  customSelect.setAttribute('aria-expanded', 'false');
  customSelect.setAttribute('aria-label', trigger.textContent);
  optionsContainer.setAttribute('role', 'listbox');

  const options = customSelect.querySelectorAll('.custom-option');
  options.forEach((opt, index) => {
    opt.setAttribute('role', 'option');
    opt.setAttribute('id', `option-${toLowerKebab(opt.textContent)}-${index}`);
  });

  // STATE HELPERS
  function openDropdown() {
    // Close others
    document.querySelectorAll('.custom-select-wrapper.open').forEach((el) => {
      if (el !== customSelect) {
        el.classList.remove('open');
        el.setAttribute('aria-expanded', 'false');
      }
    });

    customSelect.classList.add('open');
    customSelect.setAttribute('aria-expanded', 'true');

    // Focus the wrapper so it can receive keydown events
    customSelect.focus();

    // Highlight logic
    const selected = customSelect.querySelector('.custom-option.selected');
    if (selected) {
      highlightOption(Array.from(options).indexOf(selected));
    }
  }

  function closeDropdown() {
    customSelect.classList.remove('open');
    customSelect.setAttribute('aria-expanded', 'false');
    options.forEach((el) => el.classList.remove('keyboard-hover'));
  }

  function toggleDropdown() {
    if (customSelect.classList.contains('open')) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function highlightOption(index) {
    if (index < 0) index = 0;
    if (index >= options.length) index = options.length - 1;

    options.forEach((el) => el.classList.remove('keyboard-hover'));
    const target = options[index];
    target.classList.add('keyboard-hover');
    target.scrollIntoView({ block: 'nearest' });
  }

  let searchString = '';
  let searchTimeout = null;

  // EVENT LISTENERS
  // Trigger Click
  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    toggleDropdown();
  });

  // Option Click
  options.forEach((opt) => {
    opt.addEventListener('click', function (e) {
      e.stopPropagation();
      // Visual Update
      trigger.textContent = this.textContent;
      closeDropdown();

      // Data Update
      hiddenInput.value = this.dataset.value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));

      // State Update
      options.forEach((el) => {
        el.classList.remove('selected');
        el.setAttribute('aria-selected', 'false');
      });
      this.classList.add('selected');
      this.setAttribute('aria-selected', 'true');

      customSelect.classList.add('has-value');
    });
  });

  // Keyboard Interaction
  customSelect.addEventListener('keydown', function (e) {
    const isOpen = customSelect.classList.contains('open');
    let focusedIndex = -1;

    // Determine current focus index based on keyboard-hover
    options.forEach((opt, index) => {
      if (opt.classList.contains('keyboard-hover')) focusedIndex = index;
    });

    // Fallback to selected if no keyboard hover
    if (focusedIndex === -1) {
      options.forEach((opt, index) => {
        if (opt.classList.contains('selected')) focusedIndex = index;
      });
    }

    if (e.key.length === 1 && e.key.match(/\S/)) {
      e.preventDefault();

      if (!isOpen) openDropdown();

      // Build the search string
      clearTimeout(searchTimeout);
      searchString += e.key.toLowerCase();

      // Clear the buffer after 500ms of inactivity
      searchTimeout = setTimeout(() => {
        searchString = '';
      }, 1000);

      // Find the first option that starts with the search string
      const matchIndex = Array.from(options).findIndex((opt) =>
        opt.textContent.toLowerCase().trim().startsWith(searchString)
      );

      if (matchIndex >= 0) {
        highlightOption(matchIndex);
      }
      return; // Stop processing other keys
    }

    switch (e.key) {
      case ' ':
      case 'Enter':
        e.preventDefault();
        if (isOpen) {
          if (focusedIndex >= 0) {
            options[focusedIndex].click();
          } else {
            closeDropdown();
          }
        } else {
          openDropdown();
        }
        break;

      case 'ArrowDown':
        e.preventDefault();
        if (!isOpen) {
          openDropdown();
        } else {
          highlightOption(focusedIndex + 1);
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (!isOpen) {
          openDropdown();
        } else {
          highlightOption(focusedIndex - 1);
        }
        break;

      case 'Escape':
        if (isOpen) {
          e.preventDefault();
          closeDropdown();
        }
        break;

      case 'Tab':
        closeDropdown();
        break;
    }
  });
}

// Handling logic for state and country dropdowns
function buildCustomSelect(wrapper, placeholder, optionsArray, hiddenInput) {
  // Cleanup
  const existing = wrapper.querySelector('.custom-select-wrapper');
  if (existing) existing.remove();

  // Build DOM Elements
  const customSelect = document.createElement('div');
  customSelect.className = 'custom-select-wrapper';
  if (optionsArray.length === 0) customSelect.classList.add('is-empty');

  const trigger = document.createElement('div');
  trigger.className = 'custom-select-trigger';
  trigger.textContent = placeholder;
  customSelect.appendChild(trigger);

  const optionsContainer = document.createElement('div');
  optionsContainer.className = 'custom-options';

  optionsArray.forEach((opt) => {
    const optionDiv = document.createElement('div');
    optionDiv.className = 'custom-option';
    optionDiv.textContent = opt.label;
    optionDiv.dataset.value = opt.value;
    optionsContainer.appendChild(optionDiv);
  });

  customSelect.appendChild(optionsContainer);

  // Insert into Page
  const fieldContainer = hiddenInput.closest('.forminator-field');
  fieldContainer.insertBefore(customSelect, hiddenInput);
  fieldContainer.classList.add('has-custom-dropdown');

  // Attach Logic
  handleDropdownAccessibility(
    customSelect,
    trigger,
    optionsContainer,
    hiddenInput
  );
}

function fetchStates(countryName, stateWrapper, stateInput) {
  // 1. Set Loading State
  buildCustomSelect(stateWrapper, '...', [], stateInput);

  // 2. Call API
  fetch('https://countriesnow.space/api/v0.1/countries/states', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ country: countryName }),
  })
    .then((response) => response.json())
    .then((data) => {
      // 3. Validate Data
      if (
        data.error ||
        !data.data ||
        !data.data.states ||
        data.data.states.length === 0
      ) {
        buildCustomSelect(stateWrapper, 'No states available', [], stateInput);
        return;
      }

      // 4. Map API data
      const stateOptions = data.data.states.map((s) => ({
        label: s.name,
        value: s.name,
      }));

      // 5. Re-build State Dropdown with new options
      buildCustomSelect(stateWrapper, 'State', stateOptions, stateInput);
      const newDropdown = stateWrapper.querySelector('.custom-select-wrapper');
      if (newDropdown) {
        newDropdown.focus();
      }
    })
    .catch((err) => {
      console.error('State fetch error:', err);
      buildCustomSelect(stateWrapper, 'Error loading states', [], stateInput);
    });
}

function handleSubmitButtonState(form) {
  const submitBtn = form.querySelector('.forminator-button-submit');
  if (!submitBtn) return;

  // Helper to check if form has ANY data
  const checkFormValidity = () => {
    let hasData = false;

    // Check standard inputs
    const inputs = form.querySelectorAll(
      'input:not([type="hidden"]), select, textarea'
    );
    inputs.forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) hasData = true;
      } else if (input.value.trim() !== '') {
        hasData = true;
      }
    });

    // Toggle Button State
    if (hasData) {
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('forminator-button-disabled');
    } else {
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.classList.add('forminator-button-disabled');
    }
  };

  // 1. Run immediately on load
  checkFormValidity();

  // 2. Listen for changes on ANY input in the form
  form.addEventListener('change', checkFormValidity);
  form.addEventListener('input', checkFormValidity);
}

function initForminatorDropdowns() {
  const forminatorForm = document.querySelector('form[id*="forminator"]');
  if (!forminatorForm) return;

  handleSubmitButtonState(forminatorForm);

  const wrappers = document.querySelectorAll(
    '.state-dropdown, .country-dropdown'
  );

  if (!wrappers.length) return;

  // Global Close Listener
  document.addEventListener('click', function () {
    document.querySelectorAll('.custom-select-wrapper.open').forEach((el) => {
      el.classList.remove('open');
      el.setAttribute('aria-expanded', 'false');
    });
  });

  wrappers.forEach(function (wrapper) {
    const fieldParent = wrapper.querySelector('.forminator-field');
    const originalInput = fieldParent
      ? fieldParent.querySelector('input')
      : null;

    if (!originalInput || wrapper.querySelector('.custom-select-wrapper')) {
      return;
    }

    const isState = wrapper.classList.contains('state-dropdown');
    const placeholder = isState ? 'State' : 'Country';

    originalInput.style.display = 'none';

    if (isState) {
      buildCustomSelect(wrapper, placeholder, [], originalInput);
    } else {
      const countryData =
        typeof MitekSettings !== 'undefined' && MitekSettings.countries
          ? MitekSettings.countries
          : [];

      console.log(MitekSettings);

      buildCustomSelect(wrapper, placeholder, countryData, originalInput);

      originalInput.addEventListener('change', function (e) {
        const selectedCountry = e.target.value;

        // Find the State wrapper in the same form
        const stateWrapper = forminatorForm.querySelector('.state-dropdown');
        console.log(selectedCountry);
        if (stateWrapper && selectedCountry) {
          const stateInput = stateWrapper.querySelector('input');
          // Clear current value
          stateInput.value = '';
          fetchStates(selectedCountry, stateWrapper, stateInput);
        }
      });
    }
  });
}

// Main Execution
// Run ONLY if a Forminator form exists
const forminatorForm = document.querySelector('form[id*="forminator"]');

initForminatorDropdowns();

function initInteractiveMap(block) {
  // Handling dots interaction
  const mapContainers = block.querySelectorAll(
    '.module-manufacturing-map__detail-grid'
  );

  if (!mapContainers.length) return;

  mapContainers.forEach((mapContainer) => {
    const textItems = mapContainer.querySelectorAll('.location-item');
    const mapDots = mapContainer.querySelectorAll('.map-dot');

    // Helper: Reset all active states
    const resetActive = () => {
      textItems.forEach((el) => el.classList.remove('is-active'));
      mapDots.forEach((el) => el.classList.remove('is-active'));
    };

    // Helper: Activate a specific pair based on ID
    const activatePair = (uniqueId) => {
      resetActive();

      // 1. Activate Text
      const targetText = mapContainer.querySelector(
        `.location-item[data-target="${uniqueId}"]`
      );
      if (targetText) targetText.classList.add('is-active');

      // 2. Activate Dot
      const targetDot = mapContainer.querySelector(
        `.map-dot[data-id="${uniqueId}"]`
      );
      if (targetDot) targetDot.classList.add('is-active');
    };

    // Global click outside
    document.addEventListener('click', (e) => {
      if (!mapContainer.contains(e.target)) {
        resetActive();
      }
    });

    // Text items events
    textItems.forEach((item) => {
      const id = item.dataset.target;

      // Handle both hover and click
      item.addEventListener('mouseenter', () => activatePair(id));
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        activatePair(id);
      });
    });

    // Map dots events
    mapDots.forEach((dot) => {
      const id = dot.dataset.id;

      // Handle both hover and click
      dot.addEventListener('mouseenter', () => activatePair(id));
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        activatePair(id);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const mapBlock = document.querySelector('.module-manufacturing-map');
  if (!mapBlock) return;
  initInteractiveMap(mapBlock);
});

function handleHeroVideoReducedMotion() {
  const video = document.querySelector('.layout-home__video');

  if (!video) return;

  const wrapper = video.closest('.layout-home');
  const pauseBtn = wrapper
    ? wrapper.querySelector('.video-button-pause')
    : null;

  if (!pauseBtn) return;

  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  // 1. Initial State: If reduced motion is active, force pause immediately
  if (mediaQuery.matches) {
    video.pause();
    wrapper.classList.add('is-paused');
    pauseBtn.setAttribute('aria-label', 'Play Background Video');
  }

  // 2. Interaction: Handle click to toggle play/pause
  pauseBtn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      wrapper.classList.remove('is-paused');
      pauseBtn.setAttribute('aria-label', 'Pause Autoplay');
      pauseBtn.classList.remove('icon-play');
    } else {
      video.pause();
      wrapper.classList.add('is-paused');
      pauseBtn.setAttribute('aria-label', 'Play Background Video');
      pauseBtn.classList.add('icon-play');
    }
  });
}

document.addEventListener('DOMContentLoaded', () =>
  handleHeroVideoReducedMotion()
);
